import {
  Chip,
  IconButton,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Stack,
} from "@mui/material";

import { Paper } from "@mui/material";

import { TableCell } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { LeagueInformation } from "./LeagueRegistration";
import { Dispatch, SetStateAction, useState } from "react";

function LeagueRegistrationTable({
  leaguesDetails,
  setLeaguesDetails,
  displayHandicap,
  displayTeamMaximum,
  title,
  deleteTournamentLeague,
}: {
  leaguesDetails: LeagueInformation[];
  setLeaguesDetails: Dispatch<SetStateAction<LeagueInformation[]>>;
  displayHandicap: boolean;
  displayTeamMaximum: boolean;
  title: string;
  deleteTournamentLeague: (league_id: number) => void;
}) {
  const colorMapper = ["primary", "secondary", "success", "warning", "info"];
  const [editingIndex, setEditingIndex] = useState<number | null>(null);
  const [editValue, setEditValue] = useState("");
  const [editingHandicapIndex, setEditingHandicapIndex] = useState<number | null>(null);
  const [editHandicapValue, setEditHandicapValue] = useState<number>(0);

  const handleEdit = (index: number, league: LeagueInformation) => {
    setEditingIndex(index);
    setEditValue(league.league_name);
  };

  const handleEditHandicap = (index: number, league: LeagueInformation) => {
    setEditingHandicapIndex(index);
    setEditHandicapValue(league.handicap);
  };

  const handleSave = (index: number) => {
    const updatedLeagues = [...leaguesDetails];
    updatedLeagues[index] = {
      ...updatedLeagues[index],
      league_name: editValue,
    };
    setLeaguesDetails(updatedLeagues);
    setEditingIndex(null);
  };

  const handleSaveHandicap = (index: number) => {
    const updatedLeagues = [...leaguesDetails];
    updatedLeagues[index] = {
      ...updatedLeagues[index],
      handicap: editHandicapValue,
    };
    setLeaguesDetails(updatedLeagues);
    setEditingHandicapIndex(null);
  };

  const handleKeyPress = (event: React.KeyboardEvent, index: number) => {
    if (event.key === 'Enter') {
      handleSave(index);
    } else if (event.key === 'Escape') {
      setEditingIndex(null);
    }
  };

  const handleHandicapKeyPress = (event: React.KeyboardEvent, index: number) => {
    if (event.key === 'Enter') {
      handleSaveHandicap(index);
    } else if (event.key === 'Escape') {
      setEditingHandicapIndex(null);
    }
  };

  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell padding="none" sx={{ pl: 1 }}>
              {title} Name
            </TableCell>
            {displayHandicap && (
              <TableCell align="right" padding="none">
                Handicap
              </TableCell>
            )}
            {displayTeamMaximum && (
              <TableCell align="right" padding="none">
                Max Teams
              </TableCell>
            )}
            <TableCell align="right" padding="none">
              Actions
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {leaguesDetails.map((league, index) => (
            <TableRow key={index}>
              <TableCell
                component="th"
                scope="row"
                padding="none"
                sx={{ pl: 1 }}
              >
                {editingIndex === index ? (
                  <TextField
                    value={editValue}
                    onChange={(e) => setEditValue(e.target.value)}
                    onKeyDown={(e) => handleKeyPress(e, index)}
                    onBlur={() => handleSave(index)}
                    size="small"
                    autoFocus
                    sx={{ width: '150px' }}
                  />
                ) : (
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Chip
                      label={league.league_name}
                      color={
                        colorMapper[index % colorMapper.length] as
                          | "primary"
                          | "secondary"
                          | "success"
                          | "warning"
                          | "info"
                      }
                      size="small"
                    />
                    <IconButton
                      size="small"
                      onClick={() => handleEdit(index, league)}
                      sx={{ p: 0.5 }}
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                  </Stack>
                )}
              </TableCell>
              {displayHandicap && (
                <TableCell align="right" padding="none">
                  {editingHandicapIndex === index ? (
                    <TextField
                      type="number"
                      value={editHandicapValue}
                      onChange={(e) => {
                        const value = parseInt(e.target.value);
                        if (value >= -8 && value <= 40) {
                          setEditHandicapValue(value);
                        }
                      }}
                      onKeyDown={(e) => handleHandicapKeyPress(e, index)}
                      onBlur={() => handleSaveHandicap(index)}
                      size="small"
                      autoFocus
                      sx={{ width: '80px' }}
                    />
                  ) : (
                    <Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-end">
                      <span>{league.handicap}</span>
                      <IconButton
                        size="small"
                        onClick={() => handleEditHandicap(index, league)}
                        sx={{ p: 0.5 }}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </Stack>
                  )}
                </TableCell>
              )}
              {displayTeamMaximum && (
                <TableCell align="right" padding="none">
                  {league.team_maximum}
                </TableCell>
              )}
              <TableCell align="right" padding="none">
                <IconButton
                  size="small"
                  onClick={() => {
                    const updatedLeagues = leaguesDetails.filter(
                      (_, i) => i !== index
                    );
                    setLeaguesDetails(updatedLeagues);
                    if (deleteTournamentLeague && league.tournament_id) {
                      deleteTournamentLeague(league.tournament_id);
                    }
                  }}
                  color="error"
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default LeagueRegistrationTable;
